import { FunctionComponent, useCallback } from 'react';
import { StepContainer } from '../../../StepContainer';
import { useBookingCheckoutContext } from '../../../CheckoutContext/BookingContext';
import { PaymentForm } from '../../../PaymentForm';

export const PaymentStep: FunctionComponent = () => {
    const { course, checkoutState, submitResponse } = useBookingCheckoutContext();

    const onBackClick = useCallback(() => {
        return submitResponse({ actionType: 'go back', payload: {} });
    }, [submitResponse]);

    return (
        <StepContainer
            course={course}
            optimisticCheckoutState={checkoutState}
            onBackClick={onBackClick}
        >
            <h1>Payment</h1>
            <PaymentForm />
        </StepContainer>
    );
};
